"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    stickyActionBar: ()=>stickyActionBar
});
const index_cjs_namespaceObject = require("../../variants/index.cjs");
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const stickyActionBar = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: [
            'fixed bottom-0 left-0 right-0',
            'bg-neutral-1/90 shadow-card shadow-lg backdrop-blur-2xl',
            'z-50'
        ],
        headerContainer: '',
        mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2',
        textContainer: 'basis-full',
        actionContainer: 'basis-full',
        helperTextSlot: 'text-body3 text-center',
        primaryActionContainer: 'flex flex-[2]',
        secondaryActionContainer: 'flex flex-1'
    },
    variants: {
        type: index_cjs_namespaceObject.buttonTypeVariants,
        barType: {
            bookBar: {
                mainContainer: 'mp-2 flex flex-row items-center justify-between gap-2',
                textContainer: 'basis-full',
                actionContainer: 'basis-full'
            },
            actionBar: {
                mainContainer: 'flex flex-row items-center justify-between gap-2 pb-2',
                textContainer: 'basis-full',
                actionContainer: 'flex w-full flex-row gap-2'
            }
        },
        hasSecondaryAction: {
            true: {
                actionContainer: 'flex w-full flex-row gap-2'
            },
            false: {
                actionContainer: 'flex w-full'
            }
        }
    },
    compoundVariants: [
        {
            barType: 'actionBar',
            hasSecondaryAction: true,
            class: {
                actionContainer: 'flex w-full flex-row gap-2'
            }
        },
        {
            barType: 'actionBar',
            hasSecondaryAction: false,
            class: {
                actionContainer: 'flex w-full'
            }
        }
    ],
    defaultVariants: {
        type: 'primary',
        barType: 'actionBar',
        hasSecondaryAction: false
    }
});
exports.stickyActionBar = __webpack_exports__.stickyActionBar;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "stickyActionBar"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
